export const RIGHT_CLICK_PAN_THRESHOLD_PX = 3;

export function hasMovedPastPanThreshold(
  startX: number,
  startY: number,
  currentX: number,
  currentY: number,
  thresholdPx = RIGHT_CLICK_PAN_THRESHOLD_PX
): boolean {
  return (
    Math.abs(currentX - startX) > thresholdPx ||
    Math.abs(currentY - startY) > thresholdPx
  );
}

export function resolveContextMenuTarget(
  target: EventTarget | null
): Element | null {
  if (target instanceof Element) {
    return target;
  }
  if (target instanceof Node) {
    return target.parentElement;
  }
  return null;
}

export function isEventInsideElement(
  target: EventTarget | null,
  element: Element | null
): boolean {
  if (element == null) {
    return false;
  }
  const resolved = resolveContextMenuTarget(target);
  return resolved != null && element.contains(resolved);
}

export function shouldStopContextMenuPropagation(options: {
  isOpeningDeferredMenu: boolean;
  isRightClickPanPending: boolean;
  suppressNativeContextMenu?: boolean;
}): boolean {
  if (options.isOpeningDeferredMenu) {
    return false;
  }
  return (
    options.isRightClickPanPending || Boolean(options.suppressNativeContextMenu)
  );
}

export function shouldSuppressNativeContextMenuAfterGesture(
  button: number,
  hadPendingRightClick: boolean
): boolean {
  return button === 2 && hadPendingRightClick;
}

export function dispatchSyntheticContextMenu(
  target: EventTarget,
  clientX: number,
  clientY: number
): void {
  const element = resolveContextMenuTarget(target);
  if (!element) {
    return;
  }
  element.dispatchEvent(
    new MouseEvent('contextmenu', {
      bubbles: true,
      cancelable: true,
      clientX,
      clientY,
      button: 2,
      buttons: 2,
      view: window
    })
  );
}
